import { defineMessages } from "react-intl";

export default defineMessages({
    select: {
        id: "components.projectSelector.select",
        defaultMessage: "Select Project", // Projekt auswählen
    },
});
